import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { bsAccessNow, checkBsAccess } from "./bsAccess";

/*
 * A page that needs BlinkScribe access in this practice (OSA batch 6; only
 * where config/practice.js bsAccessOnly lists it -- 7825's Note Review and
 * Print Notes). Renders the page for a user with access, a spinner while the
 * one-per-session check runs, and the router's "Page not available"
 * otherwise -- so a typed URL never lands on a page that can only fail.
 */
export function BsAccessGate({ children }) {
  const [access, setAccess] = useState(bsAccessNow);
  const [done, setDone] = useState(() => bsAccessNow() !== "unknown");
  useEffect(() => {
    let alive = true;
    checkBsAccess().then((v) => {
      if (!alive) return;
      setAccess(v);
      setDone(true);
    });
    return () => {
      alive = false;
    };
  }, []);
  if (access === "yes") return children;
  if (!done) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }
  return <>Page not available</>;
}

export function withBsAccess(Page) {
  const Gated = (props) => (
    <BsAccessGate>
      <Page {...props} />
    </BsAccessGate>
  );
  Gated.displayName = `withBsAccess(${Page.displayName || Page.name || "Page"})`;
  return Gated;
}
